import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const CustomerReview = () => {
  useEffect(() => {
    // Load the VideoSuite player script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://videosuite-player-wrapper.vercel.app/assets';
    document.head.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            What Our Clients Say
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Hear directly from our clients about their experience with Namvoro's enterprise-grade digital brand management services.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="bg-slate-50 rounded-2xl p-8 shadow-xl max-w-4xl mx-auto"
        >
          <div 
            className="iv-player_responsive_padding" 
            style={{ padding: '56.25% 0 0 0', position: 'relative' }} 
            data-hash="686f1183cc7bd"
          >
            <div 
              className="iv-player_responsive_wrapper" 
              style={{ height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' }}
            >
              <div 
                className="iv-player_embed iv-player_async_p2z7746nud videoFoam=true" 
                style={{ height: '100%', position: 'relative', width: '100%' }}
              >
                <div 
                  className="iv-player_swatch" 
                  style={{ height: '100%', left: 0, opacity: 0, overflow: 'hidden', position: 'absolute', top: 0, width: '100%' }}
                >
                  <img 
                    src="https://vz-5b49b1a0-718.b-cdn.net/32d7fea3-9cfc-4b00-a431-16a64ffbcddd/thumbnail.jpg" 
                    style={{ filter: 'blur(5px)', height: '100%', objectFit: 'contain', width: '100%' }} 
                    alt="Customer testimonial video"
                    aria-hidden="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CustomerReview;